import React from "react";
import ReactSelect from "react-select";
import {
  Col,
  Container,
  FloatingLabel,
  Row,
  Form as Bform,
  Card,
} from "react-bootstrap";

const customStyles = {
  menu: (sty) => {
    return {
      ...sty,
      zIndex: 9,
    };
  },
  multiValue: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center", // Align items center
    height: 20,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#333", // Customize label color if needed
  }),
};

const ReactCustomSelect = ({
  options,
  placeholder,
  name,
  isMulti,
  field,
  form,
  formik,
  refs,
  key,
  onBlur,
}) => {
  const getValue = (optio) => {
    if (options) {
      if (Array.isArray(field.value)) {
        return options.filter((option) => field.value.includes(option?._id || option?.id));
      }
      const checkdone = isMulti
        ? options.filter((option) => field?.value.includes(option?._id || option?.id))
        : options.find((option) => option.value === field.value);
      return checkdone;
    } else {
      return isMulti ? [] : "";
    }
  };

  const onChange = (option) => {
    formik.setFieldValue(
      field.name,
      isMulti ? option.map((item) => item.value) : !option ? "" : option.value
    );
  };
  return (
    <>
      <ReactSelect
        options={options}
        placeholder={placeholder}
        name={name}
        styles={customStyles}
        ref={refs}
        maxMenuHeight={175}
        value={getValue()}
        onChange={onChange}
        isMulti={isMulti}
        isClearable={true}
        onBlur={onBlur}
      />

      <Bform.Control.Feedback
        type="invalid"
        style={
          formik.errors[field.name] && formik.touched[field.name]
            ? {
                display: "block",
              }
            : {}
        }
      >
        {formik.errors[field.name] && formik.touched[field.name] ? (
          <div class="error">{formik.errors[field.name]}</div>
        ) : null}{" "}
      </Bform.Control.Feedback>
    </>
  );
};

export default ReactCustomSelect;
